import { buildAuthFunctions } from '../helpers.js';

const authFunctions = buildAuthFunctions('settings');

export default {
    ...authFunctions,
};